<script setup lang="ts">
import type { GroupData } from '~/types/groups'

const props = defineProps<{
  group: GroupData
}>()
</script>

<template>
  <NuxtLink
    class="tw-flex tw-w-full tw-items-center tw-gap-3 tw-overflow-hidden"
    :to="`/groups/${group.id}`"
  >
    <GroupsGroupProfileImage
      :group="props.group"
      class="tw-h-10 tw-w-10 tw-bg-gray-200 tw-text-white"
    />

    <div class="tw-w-full tw-flex-shrink tw-flex-grow tw-overflow-hidden">
      <h2 class="tw-mb-1 tw-truncate tw-text-sm tw-font-semibold tw-leading-none">
        {{ props.group.title }}
      </h2>

      <GroupsMemberCount :group="props.group" hide-user-images class="tw-text-xs" />
    </div>
  </NuxtLink>
</template>
